import { Box, Heading, Image, Paragraph, ResponsiveContext } from "grommet";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import cluboutline from "../assets/images/club_outline@2x.png";
import divider from "../assets/images/divider@2x.png";
import ForwardIcon from "../assets/images/ic_arrow_forward.inline.svg";
import DownloadIcon from "../assets/images/ic_download.inline.svg";
import monkey from "../assets/images/monkey@2x.png";
import "../assets/styles/styles.scss";
import Button from "../components/Button";
import Footer from "../components/Footer";
import FormBlock from "../components/FormBlock";
import HorizontalRule from "../components/HorizontalRule";
import PageHeader from "../components/PageHeader";
import PageTitle from "../components/PageTitle";
import PersonalInformation from "../formBlocks/personalInformation";
import SpouseInformation from "../formBlocks/spouseInformation";

import rulesRegulationsPDF from "../static/Carriage House Club - Rules & Regulations.pdf";

import { useDispatch, useSelector } from "react-redux";
import { saveForm } from "../state/formSlice";
import { setStage } from "../state/globalSlice";

const currentYear = new Date().getFullYear();
function Layout(props) {
  const { handleSubmit, control, formState, setError, getValues, setValue, clearErrors, setFocus, reset } = useForm();

  const [showSpouse, setShowSpouse] = useState(false);
  const savedSpouse = useSelector((state) => state.form.relationship_status);
  const relationshipStatus = useWatch({
    control,
    name: "relationship_status", // without supply name will watch the entire form, or ['firstName', 'lastName'] to watch both
    defaultValue: savedSpouse,
  });

  const dispatch = useDispatch();
  const formRef = useRef(null);

  const size = useContext(ResponsiveContext);
  const isMobile = size === "small" || size === "xsmall" ? true : false;

  useEffect(() => {
    //console.log(relationshipStatus);
    if (relationshipStatus === "Married" || relationshipStatus === "Civil partnership") {
      setShowSpouse(true);
    } else {
      setShowSpouse(false);
    }
  }, [relationshipStatus]);

  const onSubmit = (data) => {
    dispatch(setStage(1));
  };

  const formSubmit = () => {
    const formValues = getValues();
    dispatch(saveForm(formValues));
    handleSubmit(onSubmit)();
  };

  return (
    <Box fill="horizontal">
      <PageHeader activeSection={1} />
      <Box
        width={{ max: "952px" }}
        fill="horizontal"
        alignSelf="center"
        align="center"
        pad={{
          horizontal: isMobile ? "24px" : "36px",
          top: isMobile ? "104px" : "250px",
        }}
      >
        <PageTitle
          isMobile={isMobile}
          title="Candidate for Membership"
          image={monkey}
          body={"Please kindly complete the form below with details of the candidate you wish to propose for Membership to Carriage House."}
        />
        <Paragraph margin={{ vertical: "small" }} style={{ maxWidth: "750px" }} textAlign="center" className="small straight">
        As you are sharing personal contact information with Carriage House, please do request the permission of the candidate before submitting. Please also note that all information will be treated in the strictest of confidence and we will only contact the candidate in relation to an application for Membership.
        </Paragraph>

        <Paragraph margin={{ vertical: "small" }} style={{ maxWidth: "550px" }} textAlign="center" className="small straight">
          This form will take around 5 minutes to complete and all information will be treated in the strictest of confidence.
        </Paragraph>
        <Box fill="horizontal" alignSelf="center" width={{ max: "350px" }} margin={{ top: "48px" }}>
          <Button
            // alignSelf="center"
            href={rulesRegulationsPDF}
            target={"_blank"}
            download
            multiline
            text={"Rules & Regulations"}
            icon={<DownloadIcon />}
          />
        </Box>
        <Image width="10px" src={divider} margin="large" />
        <Box pad={{ vertical: "medium" }}>
          <Image src={cluboutline} width={isMobile ? "auto" : "300px"} height={isMobile ? "48px" : "auto"} />
        </Box>

        <Paragraph fill style={{ maxWidth: "750px" }} textAlign="center" className="small straight">{`I would like to propose the following candidate for Membership to Carriage House:`}</Paragraph>

        <HorizontalRule />
        <Box fill>
          <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
            <PersonalInformation setError={setError} getValues={getValues} control={control} setValue={setValue} formState={formState} clearErrors={clearErrors} />

            {showSpouse && (
              <>
                <HorizontalRule />
                <SpouseInformation control={control} setValue={setValue} />
              </>
            )}
            <HorizontalRule />

            <FormBlock margin={{ top: "35px" }}>
              <Button onClick={formSubmit} color={"red"} text={"Next Step"} icon={<ForwardIcon />} />
            </FormBlock>
          </form>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
